var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../config/config';
import { BaseComponent } from '../../../common/components/base.component';
import { clone, isNullOrUndefined } from '../../../common/extensions';
import { ModalService } from '../../../common/services/modal.service';
import { HubApiService } from '../../../services/hub.api.service';
import { HubComponent } from '../hub.component';
import { ShowInfoModalComponent } from '../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../show.info.modal/show.info.modal.provider';
import { HubVisitorFeatureToggle } from "../../../models/hub/hub.visitor.feature.toggle";
import { ToggleStore } from "../../../stores/hub.calendar.store";
var UploadEventsComponent = /** @class */ (function (_super) {
    __extends(UploadEventsComponent, _super);
    function UploadEventsComponent(activatedRoute, parent, hubApiService, togglesStore, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.activatedRoute = activatedRoute;
        _this.parent = parent;
        _this.hubApiService = hubApiService;
        _this.togglesStore = togglesStore;
        _this.modalService = modalService;
        _this.content = [];
        _this.toggles = new HubVisitorFeatureToggle();
        _this.uploadCsvEventsExample = config.uploadCsvEventsExample;
        _this.step = 0;
        _this.newEvents = [];
        _this.isApproved = true;
        _this.result = {
            saved: null,
            updated: null,
            notSaved: null,
        };
        _this.matchHeader = [
            { field: 'Title', isMatched: false, isChecked: false, isDisabled: false, isRequired: true },
            { field: 'Time', isMatched: false, isChecked: false, isDisabled: false, isRequired: true },
            { field: 'Timezone', isMatched: false, isChecked: false, isDisabled: false, isRequired: true },
            { field: 'Description', isMatched: false, isChecked: false, isDisabled: false, isRequired: false },
            { field: 'Host', isMatched: false, isChecked: false, isDisabled: false, isRequired: true },
            { field: 'HostLink', isMatched: false, isChecked: false, isDisabled: false, isRequired: false },
            { field: 'Address', isMatched: false, isChecked: false, isDisabled: false, isRequired: true },
            { field: 'Image', isMatched: false, isChecked: false, isDisabled: false, isRequired: false },
            { field: 'EventLink', isMatched: false, isChecked: false, isDisabled: false, isRequired: false },
            { field: 'TicketUrl', isMatched: false, isChecked: false, isDisabled: false, isRequired: false },
        ];
        return _this;
    }
    UploadEventsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parent.location = 'Upload Events';
        this.header = [];
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.togglesStore.toggleCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            _this.toggles = (isNullOrUndefined(toggleCommand) || isNullOrUndefined(toggleCommand.manualEvents)) ? new HubVisitorFeatureToggle() : toggleCommand;
        });
    };
    UploadEventsComponent.prototype.showCsvContent = function (content) {
        var _this = this;
        this.header = [];
        this.content = [];
        console.log(content);
        var header = clone(content[0]);
        header.forEach(function (title) {
            var match = _this.matchHeader.first(function (x) { return x.field.toLowerCase() === title.toLowerCase(); });
            _this.header.push(new UploadEventsHeader(title, !!match, false, false, match ? match.field.toLowerCase() : null));
            if (match) {
                match.isMatched = true;
                match.isChecked = true;
                match.isDisabled = true;
            }
        });
        content.splice(0, 1);
        this.content = content;
        if (this.header.length) {
            this.step++;
        }
    };
    UploadEventsComponent.prototype.getEvents = function () {
        var _this = this;
        var required = this.checkRequired();
        if (required.length) {
            this.showInfoModal('Data Error', ['Unmatch fields found:', required.join(', '), 'Please match these fields before adding the events.']);
            return;
        }
        var events = [];
        this.newEvents = [];
        var requiredFields = [];
        this.content.forEach(function (row) {
            var event = {};
            row.forEach(function (column, columnIndex) {
                var headerColumn = _this.header[columnIndex];
                if (column) {
                    column = column.toString();
                }
                if (!column || !column.trim()) {
                    var col = _this.matchHeader.first(function (x) { return x.field.toLowerCase() === headerColumn.title.toLowerCase(); });
                    if (col && col.isRequired) {
                        requiredFields.push(headerColumn.title);
                    }
                }
                if (headerColumn.isMatched && !headerColumn.isSkipped) {
                    if (headerColumn.matchedTo.toLowerCase() === 'time') {
                        var timezone_1 = row[columnIndex + 1];
                        console.log('timezone', timezone_1);
                        if (column) {
                            var timeSeg = column.split(',');
                            event['eventTimes'] = [];
                            timeSeg.forEach(function (eachTime) {
                                var eachTimeSeg = eachTime.split(' to ');
                                var startTime = new Date(eachTimeSeg[0].trim().replace('T', ' ') + " " + timezone_1).toISOString();
                                console.log('startTime', startTime);
                                var endTime = eachTimeSeg.length > 1 ? new Date(eachTimeSeg[1].trim().replace('T', ' ') + " " + timezone_1).toISOString() : null;
                                console.log('endTime', endTime);
                                var eventTime = {};
                                eventTime['startTime'] = startTime;
                                eventTime['endTime'] = endTime;
                                event['eventTimes'].push(eventTime);
                            });
                            event['startTime'] = event['eventTimes'].first().startTime;
                            event['endTime'] = event['eventTimes'].last().endTime;
                        }
                    }
                    else {
                        event[headerColumn.matchedTo] = column;
                    }
                }
            });
            events.push(event);
        });
        events.forEach(function (x) {
            if (!_this.newEvents.any(function (y) { return y.title === x.title && y.address === x.address && y.startTime === x.startTime; })) {
                _this.newEvents.push(x);
            }
        });
        console.log(events);
        if (requiredFields.length) {
            this.showInfoModal('Data Error', ['Empty fields found:', requiredFields.join(', '), 'Please check the data and try again.']);
            return;
        }
        this.step++;
    };
    UploadEventsComponent.prototype.saveEvents = function (event) {
        var _this = this;
        this.result = {
            saved: null,
            updated: null,
            notSaved: null,
        };
        this.hubApiService.saveCsvEvents(this.hubName, this.newEvents, this.isApproved).finally(event.complete).subscribe(function (data) {
            if (data.success) {
                _this.result.saved = data.saved;
                _this.result.updated = data.updated;
                _this.result.notSaved = data.notSaved;
                _this.step = 3;
            }
        });
    };
    UploadEventsComponent.prototype.toggleSkip = function (index) {
        this.header[index].isSkipped = !this.header[index].isSkipped;
    };
    UploadEventsComponent.prototype.matchItemClick = function ($event) {
        $event && $event.stopPropagation();
    };
    UploadEventsComponent.prototype.beforeMenuOpen = function (title) {
        this.titleWorkingOn = title;
        if (title.matchedTo) {
            this.matchHeader.filter(function (x) { return x.field.toLowerCase() === title.matchedTo; }).forEach(function (x) { return x.isDisabled = false; });
            this.matchHeader.filter(function (x) { return x.field.toLowerCase() !== title.matchedTo; }).forEach(function (x) { return x.isDisabled = true; });
        }
        else {
            this.matchHeader.filter(function (x) { return x.field.toLowerCase() === title.title.toLowerCase() || !x.isMatched; }).forEach(function (x) { return x.isDisabled = false; });
            this.matchHeader.filter(function (x) { return x.field.toLowerCase() !== title.title.toLowerCase() && x.isMatched; }).forEach(function (x) { return x.isDisabled = true; });
        }
    };
    UploadEventsComponent.prototype.toggleMatch = function (header) {
        var _this = this;
        var isWorkingOnTitle = header.field.toLowerCase() === this.titleWorkingOn.title.toLowerCase();
        this.matchHeader.forEach(function (x) { return x.isDisabled = true; });
        this.header.filter(function (x) { return x.title.toLowerCase() === header.field.toLowerCase(); }).forEach(function (title) { return title.isMatched = !title.isMatched; });
        if (!header.isChecked) {
            if (isWorkingOnTitle) {
                this.matchHeader.filter(function (x) { return !x.isChecked || x === header; }).forEach(function (x) { return x.isDisabled = false; });
            }
            else {
                this.matchHeader.filter(function (x) { return !x.isChecked; }).forEach(function (x) { return x.isDisabled = false; });
            }
            this.header.filter(function (x) { return x.title.toLowerCase() === _this.titleWorkingOn.title.toLowerCase(); }).forEach(function (x) {
                x.matchedTo = null;
                x.isMatched = false;
            });
        }
        else {
            this.matchHeader.filter(function (x) { return x === header; }).forEach(function (x) { return x.isDisabled = false; });
            this.titleWorkingOn.isMatched = true;
            this.titleWorkingOn.matchedTo = header.field.toLowerCase();
            this.header.filter(function (x) { return x.title.toLowerCase() === _this.titleWorkingOn.title.toLowerCase(); }).forEach(function (x) {
                x.matchedTo = header.field.toLowerCase();
                x.isMatched = true;
            });
        }
    };
    UploadEventsComponent.prototype.checkRequired = function () {
        var required = [];
        this.matchHeader.forEach(function (x) {
            if (x.isRequired && !x.isChecked) {
                required.push(x.field);
            }
        });
        return required;
    };
    UploadEventsComponent.prototype.showInfoModal = function (title, info) {
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData(title, null, info)
                }
            ],
            panelClass: 'width-modal-2'
        });
    };
    return UploadEventsComponent;
}(BaseComponent));
export { UploadEventsComponent };
var UploadEventsHeader = /** @class */ (function () {
    function UploadEventsHeader(title, isMatched, isSkipped, isDisabled, matchedTo) {
        if (matchedTo === void 0) { matchedTo = null; }
        this.title = title;
        this.isMatched = isMatched;
        this.isSkipped = isSkipped;
        this.isDisabled = isDisabled;
        this.matchedTo = matchedTo;
    }
    return UploadEventsHeader;
}());
export { UploadEventsHeader };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/upload.events/upload.events.component.ts.pre-build-optimizer.js